/**
 * Statut d'un site — fonction partagee (source unique).
 * Priorite : Inactif > Incident > Sous-effectif > En attente > Operationnel
 *
 * Regle metier (par creneau actif) :
 *   0 pointe sur N requis  → En attente (bleu) — statut inconnu, ne pas alarmer
 *   1..N-1 pointes         → Sous-effectif (orange) — absences confirmees
 *   N pointes              → Operationnel (vert)
 *   Incident actif         → Incident (rouge) — priorite absolue
 *   site.actif === false   → Inactif (gris)
 *
 * @param {Object} site — doit contenir: actif, incidents_actifs, agents_presents, effectif_requis
 * @returns {{ label: string, color: string, cls: string }}
 */
export function getSiteStatus(site) {
  if (!site.actif)
    return { label: 'Inactif', color: '#888', cls: 'gss-badge-grey' };
  if (site.incidents_actifs > 0)
    return { label: `${site.incidents_actifs} incident(s)`, color: '#e53935', cls: 'gss-badge-red' };
  if (site.effectif_requis > 0 && site.agents_presents > 0 && site.agents_presents < site.effectif_requis)
    return { label: 'Sous-effectif', color: '#FF9100', cls: 'gss-badge-orange' };
  if (site.effectif_requis > 0 && site.agents_presents === 0)
    return { label: 'En attente', color: '#5C7FA8', cls: 'gss-badge-blue' };
  return { label: 'Operationnel', color: '#00C853', cls: 'gss-badge-green' };
}
